import { StoreDoc } from '@gooduncles/gu-app-schema';
import useSWR from 'swr';

import { getStore } from 'src/utils/firebase/firebase-short-cut';
import { getStoresWithNotesOrAccessInfo } from 'src/utils/partners-util';

const fetchStore = async (params: [string, string[]]) => {
  // 여러 fetch 일괄 실행
  const results = await Promise.all(params[1].map(getStore));
  return results.filter(Boolean); // 유효한 데이터만 반환
};

/**
 * 필수지참 정보가 있는 가게만 필터링
 * @param locationIds 가게 위치 id 리스트
 * @returns 필수지참 정보가 있는 가게 리스트
 */
const useStoreCheckListData = (locationIds: string[]) => {
  const { data, error, isLoading, mutate } = useSWR(['getStores', locationIds], fetchStore, {
    shouldRetryOnError: false,
  });
  const storeDocs = data?.filter((doc) => doc) as StoreDoc[];
  const { deliveryMemoList, accessInfoListLength, groupedAccessInfoList } = getStoresWithNotesOrAccessInfo(storeDocs);

  const refetchFailedQueries = () => {
    mutate();
  };

  return {
    deliveryMemoList,
    accessInfoListLength,
    groupedAccessInfoList,
    isLoading,
    error,
    refetchFailedQueries,
  };
};

export default useStoreCheckListData;
